import React from 'react'
import Headroom from 'react-headroom'

import 'bootstrap/dist/css/bootstrap.css'
import '../scss/main.scss'
import { graphql, Link, StaticQuery } from "gatsby"
import AniLink from "gatsby-plugin-transition-link/AniLink/index"
import Helmet from "react-helmet"
import SanitizeHTML from 'react-sanitized-html'

class Header extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showSubMenu: false,
      showMagazineMenu: (props.magazine || props.allMagazines),
      showProjectsMenu: (props.projects && !props.projectType),
      showEditionsMenu: false,
      showSearch: false,
      searchResults: [],
      searchLoading: true,
      searchTerm: null,
      currentProjectSection: null,
      showAboutMenu: (props.isAbout),
      showSheyiProjectsMenu: (props.isSheyi),
    };
  }

  closeSubMenu(){
    this.setState({
      showSubMenu: false,
      // showEditionsMenu: false,
      // showProjectsMenu: false,
      // showMagazineMenu: false,
      // currentProjectSection: null
    })
  }

  closeSearch(){
    this.setState({
      showSearch: false
    })
  }

  toggleSubMenu(){
    this.setState({
      showSubMenu: !this.state.showSubMenu,
      // showEditionsMenu: false
    })

    if(this.state.showSubMenu) {
      this.setState({
        // showMagazineMenu: false,
        // showProjectsMenu: false,
        // showEditionsMenu: false
      })
    }
  }

  search(e){
    e.preventDefault();

    this.setState({
      searchResults: [],
      searchLoading: true,
      noResults: false
    })

    fetch('https://cms.nextleveluk.com/wp-json/next-level/magazine/search?q=' + this.state.searchTerm)
    .then(response => response.json())
    .then((resultData) => {
      if(resultData.results.length > 0){
        this.setState({
          noResults: false,
          searchResults: resultData.results,
          searchLoading: false
        })
      }
      else {
        this.setState({
          noResults: true,
          searchResults: resultData.results,
          searchLoading: false
        })
      }
    })
  }

  toggleSearch(e){
    e.preventDefault()

    this.setState({
      showSearch: !this.state.showSearch
    })

    if(this.state.showSearch) {
      this.setState({
        showMagazineMenu: false,
        showProjectsMenu: false,
        showSheyiProjectsMenu: false,
      })
    }
  }

  toggleMagazineMenu(){
    this.setState({
      showMagazineMenu: !this.state.showMagazineMenu,
      showProjectsMenu: false,
      showAboutMenu: false,
      showEditionsMenu: false,
      showSheyiProjectsMenu: false,
      currentProjectSection: null
    })
  }

  toggleAboutMenu(){
    this.setState({
      showAboutMenu: !this.state.showAboutMenu,
      showMagazineMenu: false,
      showProjectsMenu: false,
      showEditionsMenu: false,
      showSheyiProjectsMenu: false,
      currentProjectSection: null
    })
  }

  toggleProjectsMenu(){
    this.setState({
      showProjectsMenu: !this.state.showProjectsMenu,
      showMagazineMenu: false,
      showAboutMenu: false,
      showEditionsMenu: false,
      showSheyiProjectsMenu: false,
      currentProjectSection: null
    })
  }

  toggleSheyiMenu(){
    this.setState({
      showProjectsMenu: false,
      showMagazineMenu: false,
      showAboutMenu: false,
      showEditionsMenu: false,
      showSheyiProjectsMenu: !this.state.showSheyiProjectsMenu,
      currentProjectSection: null
    })
  }

  toggleEditionsMenu(){
    console.log('Hereo')
    if (typeof window !== "undefined") {
      if (window.outerWidth <= 767) {
        window.location.href = '/magazines/'
      } else {
        this.setState({
          showProjectsMenu: false,
          showSheyiProjectsMenu: false,
          showAboutMenu: false,
          showMagazineMenu: true,
          showEditionsMenu: !this.state.showEditionsMenu
        })
      }
    }
  }

	render(){
    let sheyi = false

    if(typeof this.props.pageContext.navigation !== 'undefined' && (!!this.props.pageContext.navigation[0] || !!this.props.pageContext.navigation[1])) {
      sheyi = this.props.pageContext.navigation[0].options ? this.props.pageContext.navigation[0].options.showSheyiSection : this.props.pageContext.navigation[1].options.showSheyiSection;
    }

		return (
      <StaticQuery
        query={graphql`
          query HeadingQuery {
          allPages {
              nodes {
                  title
                  isHomepage
                  video
                  backgroundColor
                  content
                  page_id,
                  alternative_children {
                    title
                    slug
                  }
              }
          }
          allFeatures {
              edges {
                node {
                  title
                  slug
                  projects {
                    title
                    slug
                  }
                }
              }
            }
            allListings {
              edges {
                node {
                  title
                  slug
                  projects {
                    title
                    slug
                  }
                }
              }
            }
            allSheyifeatures {
              edges {
                node {
                  title
                  slug
                  image {
                    url
                  }
                  projects {
                    title
                    slug
                  }
                }
              }
            }
            allSheyilistings {
              edges {
                node {
                  title
                  slug
                  image {
                    sidebar
                  }
                }
              }
            }
            allFullprojecttypes {
              edges {
                node {
                  title
                  slug
                  projects {
                    title
                    slug
                  }
                }
              }
            }
            allProjects {
              edges {
                node {
                  title
                  slug
                }
              }
            }
            allMagazines {
              edges {
                node {
                  title
                  slug
                }
              }
            }
          }
        `}
        render={(data) => {
         let pages = data.allPages.nodes;

          let aboutPage = {};
          if(!!pages) {
            pages.forEach((item) => {
              if (item.page_id === '2') {
                aboutPage = item;
              }
            })
          }

          return (
          <React.Fragment>
            <Helmet
              bodyAttributes={{
                class: [
                  (this.state.showSearch ? 'search-open' : '') + (this.state.showSubMenu ? ' menu-open' : '')
                ]
              }}
            />

            <div id="top" />
            <div className={"search-container " + (this.state.showSearch ? 'active' : '')}>
              <button onClick={() => this.closeSearch()} className="the-close">
                <svg xmlns="http://www.w3.org/2000/svg" width="71.414" height="71.414" viewBox="0 0 71.414 71.414">
                  <g id="Group_1847" transform="translate(-531.793 -805.793)">
                    <path id="Path_1090" d="M-3308.407-12796.381l70,70" transform="translate(3840.907 13602.881)" fill="none" stroke="#000" strokeWidth="2"/>
                    <path id="Path_1091" d="M0,0,70,70" transform="translate(532.5 876.5) rotate(-90)" fill="none" stroke="#000" strokeWidth="2"/>
                  </g>
                </svg>
              </button>

              <div className="container-fluid">
                <form onSubmit={(e) => this.search(e)}>
                  <input onKeyUp={(e) => this.setState({searchTerm: e.target.value})} type="text" placeholder={'Search...'}/>
                </form>
              </div>

              <div className="container-fluid search-results-container">
                <div className="row">
                  <div className="col-lg-8">
                    {this.state.noResults && <p className={'no-results'}>No results found...</p>}

                    {!this.state.noResults && this.state.searchResults.map((res, key) => {
                      if(res.type==='article') {
                        return (
                          <div key={key} className="result">
                            <small><strong>{res.section}</strong> / {res.parent}</small>
                            <h3><AniLink cover direction={"left"} bg={res.magazineContentPageImageColour}
                                 to={'/article/' + res.slug}>{res.title}</AniLink>
                            </h3>
                            <p>{res.excerpt}</p>
                          </div>
                        )
                      }

                      if(res.type==='projects') {
                        if(!!res.externalURL && res.externalURL.length > 0){
                          return (
                            <div key={key} className="result">
                              <small><strong>{res.section}</strong> / {res.parent}</small>
                              <h3><a href={res.externalURL} target={'_blank'}><SanitizeHTML html={res.title}/></a>
                              </h3>
                              <p>{res.excerpt}</p>
                            </div>
                          )
                        }
                        return (
                          <div key={key} className="result">
                            <small><strong>{res.section}</strong> / {res.parent}</small>
                            <h3><AniLink cover direction={"left"} bg={res.magazineContentPageImageColour}
                                         to={'/project/' + res.slug}><SanitizeHTML html={res.title}/></AniLink>
                            </h3>
                            <p>{res.excerpt}</p>
                          </div>
                        )
                      }

                      if(res.type==='sheyi') {
                        if(!!res.externalURL && res.externalURL.length > 0){
                          return (
                            <div key={key} className="result">
                              <small><strong>{res.section}</strong> / {res.parent}</small>
                              <h3><a href={res.externalURL} target={'_blank'}><SanitizeHTML html={res.title}/></a>
                              </h3>
                              <p>{res.excerpt}</p>
                            </div>
                          )
                        }
                        return (
                          <div key={key} className="result">
                            <small><strong>{res.section}</strong> / {res.parent}</small>
                            <h3><AniLink cover direction={"left"} bg={res.magazineContentPageImageColour}
                                         to={'/sheyi-bankale-project/' + res.slug}><SanitizeHTML html={res.title}/></AniLink>
                            </h3>
                            <p>{res.excerpt}</p>
                          </div>
                        )
                      }
                    })}
                  </div>
                </div>
              </div>
            </div>

              <Headroom style={{backgroundColor: this.props.background ? this.props.background : '#fff'}} onUnpin={() => {this.closeSubMenu();}} className="main">
                <div className="container-fluid">
                  <div className="row">
                    <div className="col-md-3 d-flex d-md-block justify-content-between">
                      <Link to={'/'}>Next Level</Link>

                      <div className="d-md-none">
                        {!this.state.showSubMenu &&
                        <button onClick={() => this.toggleSubMenu()}>Menu</button>
                        }

                        {this.state.showSubMenu &&
                          <button onClick={() => this.closeSubMenu()}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="31.414" height="31.414"
                                 viewBox="0 0 71.414 71.414">
                              <g id="Group_1847" transform="translate(-531.793 -805.793)">
                                <path id="Path_1090" d="M-3308.407-12796.381l70,70"
                                      transform="translate(3840.907 13602.881)" fill="none" stroke="#000"
                                      strokeWidth="2"/>
                                <path id="Path_1091" d="M0,0,70,70" transform="translate(532.5 876.5) rotate(-90)"
                                      fill="none" stroke="#000" strokeWidth="2"/>
                              </g>
                            </svg>
                          </button>
                        }
                      </div>
                    </div>

                    <div className="col-md-6 d-none d-md-block">
                      {this.props.allMagazines && <button onClick={() => this.toggleSubMenu()} className="current-article">Magazine</button>}
                      {this.props.magazine && this.props.magazine.title && <button onClick={() => this.toggleSubMenu()} className="current-article">Magazine: {this.props.magazine.title}</button>}
                      {this.props.projectType && !this.props.isSheyi && this.props.projectType.title && <button onClick={() => this.toggleSubMenu()} className="current-article">Projects: {this.props.projectType.title}</button>}
                      {this.props.projectType && this.props.isSheyi && this.props.projectType.title && <button onClick={() => this.toggleSubMenu()} className="current-article">Projects: {this.props.projectType.title}</button>}
                      {this.props.projects && !this.props.projectType && <button onClick={() => this.toggleSubMenu()} className="current-article">Projects</button>}
                      {this.props.isSheyi && !this.props.projectType && <button onClick={() => this.toggleSubMenu()} className="current-article">Sheyi Bankale: Art Projects</button>}
                      {this.props.isAbout && <button onClick={() => this.toggleSubMenu()} className="current-article">About</button>}
                    </div>

                    <div className="col-md-3 d-none d-md-inline-block">
                      {!this.state.showSubMenu &&
                       <button onClick={(e) => this.toggleSearch(e)}>Search</button>
                      }

                      <button onClick={() => this.closeSubMenu()} className={"the-sub-close" + (this.state.showSubMenu ? ' active' : '')}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="71.414" height="71.414" viewBox="0 0 71.414 71.414">
                          <g id="Group_1847" transform="translate(-531.793 -805.793)">
                            <path id="Path_1090" d="M-3308.407-12796.381l70,70" transform="translate(3840.907 13602.881)" fill="none" stroke={this.props.background === '#000' || this.props.background === '#000000' ? '#fff' : "#000"} strokeWidth="2"/>
                            <path id="Path_1091" d="M0,0,70,70" transform="translate(532.5 876.5) rotate(-90)" fill="none" stroke={this.props.background === '#000' || this.props.background === '#000000' ? '#fff' : "#000"} strokeWidth="2"/>
                          </g>
                        </svg>
                      </button>
                    </div>
                  </div>
                </div>

                  <div className={"dropdown " + (this.state.showSubMenu ? 'active' : '')}>
                    <div className="container-fluid">
                      <div className="row">
                        <div className="col-lg-12">
                          <div className="row">
                            <div className="col-md-3 col-4 ">
                              <ul className={'active'}>
                                <li>
                                  <button className={this.state.showMagazineMenu ? 'active' : ''} onClick={() => this.toggleMagazineMenu()}>Magazine</button>
                                </li>
                                <li><button className={this.state.showProjectsMenu ? 'active' : ''} onClick={() => this.toggleProjectsMenu()}>Projects</button></li>
                                <li><button className={this.state.showAboutMenu ? 'active' : ''} onClick={() => this.toggleAboutMenu()}>About</button></li>
                                {/*<li><Link to="/about">About</Link></li>*/}
                                {!!sheyi && <li><button className={this.state.showSheyiProjectsMenu ? 'active' : ''} onClick={() => this.toggleSheyiMenu()}>Sheyi Bankale</button></li>}
                                <li><button className={"col-md-none"} onClick={(e) => this.toggleSearch(e)}>Search</button></li>
                              </ul>
                            </div>

                            <div className="col-lg-3 col-md-4 col-8">

                              <ul className={"sub-menu " + (this.state.showAboutMenu ? 'active' : '')}>
                                <li><Link to="/about">About</Link></li>

                                {!!aboutPage && aboutPage.alternative_children.map((page, key) => {
                                  return <li><Link to={'/about/' + page.slug}>{page.title}</Link></li>
                                })}
                              </ul>

                              <ul className={"sub-menu " + (this.state.showMagazineMenu && this.props.magazine ? 'active' : '')}>
                                {this.props.magazine &&
                                  <React.Fragment>
                                    <li>
                                      {typeof window !== 'undefined' && window.location.pathname.indexOf(this.props.magazine.slug) > -1 &&
                                        <button onClick={() => this.closeSubMenu()}>Contents {this.props.magazine.magazineNumber}</button>
                                      }

                                      {typeof window !== 'undefined' && window.location.pathname.indexOf(this.props.magazine.slug) === -1 &&
                                      <AniLink cover direction={"right"} bg={"#b0383a"} to={"/magazine/" + this.props.magazine.slug}>Contents {this.props.magazine.magazineNumber}</AniLink>
                                      }
                                    </li>

                                    {this.props.previousArticle &&
                                      <li><AniLink cover direction={"left"} bg={'#b0383a'} to={"/article/" + this.props.previousArticle.slug}>Previous article</AniLink></li>
                                    }
                                    {this.props.nextArticle &&
                                      <li><AniLink cover direction={"left"} bg={'#b0383a'} to={"/article/" + this.props.nextArticle.slug}>Next article</AniLink></li>
                                    }
                                  </React.Fragment>
                                }

                                <li><button className={this.state.showEditionsMenu ? 'active' : ''} onClick={() => this.toggleEditionsMenu()}>Editions</button></li>
                              </ul>

                              <ul className={"sub-menu " + (this.state.showSheyiProjectsMenu ? 'active' : '')}>
                                <li><AniLink direction={"right"} fade
                                             to={"/sheyi-bankale"}>Sheyi Bankale</AniLink></li>
                                {!!data.allSheyifeatures && data.allSheyifeatures.edges.map((item, key) => {
                                  return (
                                    <li key={key}>
                                      <a className={'d-none d-md-inline' + (this.state.currentProjectSection === item.node.slug ? ' active' : '')} onClick={(e) => {
                                        e.preventDefault();
                                        this.setState({currentProjectSection: item.node.slug})
                                      }} href={"/sheyi-bankale-projects/" + item.node.slug}>{item.node.title}</a>

                                      <AniLink className={'d-md-none'} direction={"right"} fade onClick={(e) => {
                                        e.preventDefault();
                                        this.setState({currentProjectSection: item.node.slug})
                                      }} to={"/sheyi-bankale-projects/" + item.node.slug}>{item.node.title}</AniLink>
                                    </li>
                                  )
                                })}

                                {!!data.allSheyilistings && data.allSheyilistings.edges.map((item, key) => {
                                  return (
                                    <li key={key}>
                                      <AniLink direction={"right"} onClick={(e) => {
                                        e.preventDefault();
                                        this.closeSubMenu();}} fade to={"/sheyi-bankale-projects/" + item.node.slug}>{item.node.title}</AniLink>
                                    </li>
                                  )
                                })}
                              </ul>

                              <ul className={"sub-menu " + (this.state.showProjectsMenu ? 'active' : '')}>
                                <li><AniLink direction={"right"} onClick={(e) => {
                                  e.preventDefault();
                                  this.closeSubMenu();}}  fade
                                                       to={"/projects"}>All Projects</AniLink></li>
                                {data.allFeatures.edges.map((item, key) => {
                                  return (
                                    <li key={key}>
                                      <a className={'d-none d-md-inline' + (this.state.currentProjectSection === item.node.slug ? ' active' : '')} onClick={(e) => {
                                        e.preventDefault();
                                        this.setState({currentProjectSection: item.node.slug})
                                      }} href={"/projects/" + item.node.slug}>{item.node.title}</a>

                                      <AniLink className={'d-md-none'} direction={"right"} fade onClick={(e) => {
                                        e.preventDefault();
                                        this.setState({currentProjectSection: item.node.slug})
                                      }} to={"/projects/" + item.node.slug}>{item.node.title}</AniLink>
                                    </li>
                                  )
                                })}

                                {data.allListings.edges.map((item, key) => {
                                  return (
                                    <li key={key}>
                                      {/*<a className={'d-none d-md-inline'} onClick={(e) => {*/}
                                      {/*  e.preventDefault();*/}
                                      {/*  this.setState({currentProjectSection: item.node.slug})*/}
                                      {/*}} href={"/projects/" + item.node.slug}>{item.node.title}</a>*/}

                                      <AniLink direction={"right"} onClick={(e) => {
                                        e.preventDefault();
                                        this.closeSubMenu();}} fade to={"/projects/" + item.node.slug}>{item.node.title}</AniLink>
                                    </li>
                                  )
                                })}
                              </ul>

                              <ul className={"sub-menu " + (this.state.showMagazineMenu && !this.props.magazine ? 'active' : '')}>
                                <li>
                                  <AniLink onClick={(e) => {
                                    e.preventDefault();
                                    this.closeSubMenu();}}  className={''} direction={"right"} fade to={"/magazines"}>All editions (covers)</AniLink>
                                </li>

                                {data.allMagazines.edges.map((item, key) => {
                                  return (
                                    <li key={key}><AniLink className={!!this.props.magazine && item.node.slug === this.props.magazine.slug ? 'active' : ''} direction={"right"} fade to={"/magazine/" + item.node.slug}>{item.node.title}</AniLink></li>
                                  )
                                })}
                              </ul>
                            </div>

                            <div className="col-6 col-lg-6 col-md-5 d-none d-md-block">
                              <ul className={"sub-menu " + (this.state.showEditionsMenu ? 'active' : '')}>
                                <li><AniLink direction={"right"} fade to={"/magazines"}>All editions (covers)</AniLink></li>
                                {data.allMagazines.edges.map((item, key) => {
                                  return (
                                    <li key={key}>
                                      <AniLink className={!!this.props.magazine && item.node.slug === this.props.magazine.slug ? 'active no-wrap' : 'no-wrap'} direction={"right"} fade to={"/magazine/" + item.node.slug}>{item.node.title}</AniLink>
                                    </li>
                                  )
                                })}
                              </ul>

                              {data.allFeatures.edges.map((type, key) => {
                                return (
                                <ul key={key} className={"sub-menu " + (this.state.currentProjectSection === type.node.slug ? 'active' : '')}>
                                  <li><AniLink direction={"right"} fade to={"/projects/" + type.node.slug}>All {type.node.title}</AniLink></li>

                                  {type.node.projects.map((item, key) => {
                                    return (
                                      <li key={key}>
                                        <AniLink direction={"right"} fade to={"/project/" + item.slug}>{item.title}</AniLink></li>
                                    )
                                  })}
                                </ul>
                                )
                              })}

                              {!!data.allSheyifeatures && data.allSheyifeatures.edges.map((type, key) => {
                                return (
                                  <ul key={key} className={"sub-menu " + (this.state.currentProjectSection === type.node.slug ? 'active' : '')}>
                                    <li><AniLink direction={"right"} fade to={"/sheyi-bankale-project/" + type.node.slug}>All {type.node.title}</AniLink></li>

                                    {type.node.projects.map((item, key) => {
                                      return (
                                        <li key={key}>
                                          <AniLink direction={"right"} fade to={"/sheyi-bankale-project/" + item.slug}>{item.title}</AniLink></li>
                                      )
                                    })}
                                  </ul>
                                )
                              })}

                              {/*{data.allListings.edges.map((type, key) => {*/}
                              {/*  return (*/}
                              {/*    <ul key={key} className={"sub-menu " + (this.state.currentProjectSection === type.node.slug ? 'active' : '')}>*/}
                              {/*      <li><AniLink direction={"right"} fade to={"/projects/" + type.node.slug}>All {type.node.title}</AniLink></li>*/}

                              {/*      {type.node.projects.map((item, key) => {*/}
                              {/*        return (*/}
                              {/*          <li key={key}>*/}
                              {/*            <AniLink direction={"right"} fade to={"/project/" + item.slug}>{item.title}</AniLink></li>*/}
                              {/*        )*/}
                              {/*      })}*/}
                              {/*    </ul>*/}
                              {/*  )*/}
                              {/*})}*/}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
              </Headroom>
          </React.Fragment>
        )}}
      />
		)
	}
}

export default Header;
